// src/polyfills.js
// Imported FIRST in index.js (import order = evaluation order), so these are
// in place before react-pdf/pdf.js load.
//
// pdf.js 4.x (react-pdf's PDF viewer - exam exhibits/requirements and the
// marker's annotation screen) calls Promise.withResolvers, which only exists
// from Chrome 119 (Nov 2023). Older Macs stuck on an older macOS can't get a
// newer Chrome, and without this, opening a PDF crashed the whole page to a
// blank white screen (a student hit this 2026-09-27 on an older MacBook Air).
//
// The PDF worker runs in its own thread, which this can't reach, so
// NEEDS_LEGACY_PDF_WORKER tells utils/pdfWorker.js to load pdf.js's own
// legacy worker build (which carries its own polyfills) on those browsers.
// Checked BEFORE patching, so up-to-date browsers are completely unaffected.

export const NEEDS_LEGACY_PDF_WORKER = typeof Promise.withResolvers !== 'function';

if (typeof Promise.withResolvers !== 'function') {
  // eslint-disable-next-line no-extend-native
  Promise.withResolvers = function withResolvers() {
    let resolve;
    let reject;
    const promise = new this((res, rej) => { resolve = res; reject = rej; });
    return { promise, resolve, reject };
  };
}
